import create from 'zustand'
import {persist} from 'zustand/middleware'

interface RecentGame {
  gameCode: string
  time: number
}

type RecentlyPlayedGames = {
  games: RecentGame[]
  add: (gameCode: string) => void
  remove: (gameCode: string) => void
}

const STORE_LIMIT = 15

function getFilteredGames(state: RecentlyPlayedGames, gameCode: string) {
  return state.games.filter((game) => game.gameCode !== gameCode)
}

export const useRecentlyPlayed = create<RecentlyPlayedGames>(
  persist(
    (set, get) => ({
      games: [],
      remove: (gameCode: string) =>
        set((state) => {
          get
          state.games = getFilteredGames(state, gameCode)
        }),
      add: (gameCode: string) =>
        set((state) => {
          let games = [{gameCode, time: Date.now()}, ...getFilteredGames(state, gameCode)]
          if (games.length > STORE_LIMIT) {
            games = games.slice(0, STORE_LIMIT)
          }
          state.games = games
        }),
    }),
    {
      name: 'Gamezop.RecentlyPlayedGames',
      getStorage: () => localStorage,
    },
  ),
)

export const isRecentlyPlayed = (gameCode: string) =>
  useRecentlyPlayed.getState().games.some((game) => game.gameCode === gameCode)

export const getLastPlayedIndex = (gameCode: string) => {
  const code = typeof gameCode === 'string' ? gameCode : ''
  return useRecentlyPlayed.getState().games.findIndex((game) => game.gameCode === code)
}
